import React, { useState } from "react";
import { airlineLogo } from "@/lib/api";

// Premium two-row airline showcase — real logos + BOLD CAPITAL names in glass cards.
const AIRLINES = [
  { code: "EK", name: "EMIRATES" },
  { code: "QR", name: "QATAR AIRWAYS" },
  { code: "BA", name: "BRITISH AIRWAYS" },
  { code: "SQ", name: "SINGAPORE AIRLINES" },
  { code: "LH", name: "LUFTHANSA" },
  { code: "AF", name: "AIR FRANCE" },
  { code: "EY", name: "ETIHAD AIRWAYS" },
  { code: "TK", name: "TURKISH AIRLINES" },
  { code: "CX", name: "CATHAY PACIFIC" },
  { code: "QF", name: "QANTAS" },
  { code: "VS", name: "VIRGIN ATLANTIC" },
  { code: "AI", name: "AIR INDIA" },
  { code: "KL", name: "KLM" },
  { code: "DL", name: "DELTA" },
  { code: "AA", name: "AMERICAN" },
  { code: "UA", name: "UNITED" },
];

const Mark = ({ code }) => {
  const [err, setErr] = useState(false);
  if (err) {
    return (
      <div className="w-9 h-9 rounded-lg bg-brand/20 text-brand flex items-center justify-center font-heading font-black text-xs shrink-0">
        {code}
      </div>
    );
  }
  return (
    <img
      src={airlineLogo(code)}
      alt={code}
      onError={() => setErr(true)}
      className="w-9 h-9 rounded-lg object-contain bg-white p-1 shrink-0"
    />
  );
};

const Card = ({ a }) => (
  <div
    className="flex items-center gap-3 mx-2.5 px-5 py-3 rounded-2xl glass-dark shrink-0 hover:border-brand/70 hover:shadow-[0_0_24px_rgba(224,0,128,0.35)] transition-all duration-300"
    data-testid={`airline-${a.code}`}
  >
    <Mark code={a.code} />
    <span className="font-heading font-black tracking-wider text-base sm:text-lg text-white whitespace-nowrap uppercase">
      {a.name}
    </span>
  </div>
);

const Row = ({ items, reverse }) => (
  <div className="relative overflow-hidden py-1.5">
    <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
      {[...items, ...items].map((a, i) => (
        <Card key={`${a.code}-${i}`} a={a} />
      ))}
    </div>
  </div>
);

export const AirlineMarquee = () => {
  const half = Math.ceil(AIRLINES.length / 2);
  const rowA = AIRLINES.slice(0, half);
  const rowB = AIRLINES.slice(half);
  return (
    <div className="relative" data-testid="airline-marquee">
      <Row items={rowA} />
      <Row items={rowB} reverse />
      <div className="pointer-events-none absolute inset-y-0 left-0 w-28 bg-gradient-to-r from-slate-950 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-28 bg-gradient-to-l from-slate-950 to-transparent" />
    </div>
  );
};
